export default __webpack_public_path__ + "static/media/payment-icon.db8cfe01.svg";